import axios from 'axios';
import { API } from '../config/BackendUrl';

const NFTDrafttoken = `${API}/NFTDraft`;
const CollectionDrafttoken = `${API}/CollectionDraft`;


export const getAllNFTDrafts = async () => {
  const config = {
    method: "get",
    url: `${NFTDrafttoken}/drafts`,
    headers: {
      "Content-Type": "application/json",
    },
  };
  try {
    const res = await axios(config);
    return res.data;
  } catch (error) {
    return error.response.data;
  }
};
export const createNFTDraft = async (data) => {
    const config = {
      method: "post",
      url: `${NFTDrafttoken}/drafts`,
      headers: {
        "Content-Type": "application/json",
      },
      data,
    };
    try {
      const res = await axios(config);
      return res.data;
    } catch (error) {
      return error.response.data;
    }
  };
  export const getNFTDraftsByWallet = async (walletAddress) => {
    const config = {
      method: "get",
      url: `${NFTDrafttoken}/drafts/wallet/${walletAddress}`,
      headers: {
        "Content-Type": "application/json",
      },
    };
    try {
      const res = await axios(config);
      return res.data;
    } catch (error) {
      return error.response.data;
    }
  };
  export const getNFTDraftsById = async (id) => {
    const config = {
      method: "get",
      url: `${NFTDrafttoken}/drafts/${id}`,
      headers: {
        "Content-Type": "application/json",
      },
    };
    try {
      const res = await axios(config);
      return res.data;
    } catch (error) {
      return error.response.data;
    }
  };
  export const updateNFTDraft = async (id, data) => {
    const config = {
      method: "put",
      url: `${NFTDrafttoken}/drafts/${id}`,
      headers: {
        "Content-Type": "application/json",
      },
      data,
    };
    try {
      const res = await axios(config);
      return res.data;
    } catch (error) {
      return error.response.data;
    }
  };
  export const deleteNFTDraft = async (id) => {
    const config = {
      method: "delete",
      url: `${NFTDrafttoken}/drafts/${id}`,
      headers: {
        "Content-Type": "application/json",
      },
    };
    try {
      const res = await axios(config);
      return res.data;
    } catch (error) {
      return error.response.data;
    }
  };

  export const getAllCollectionDrafts = async () => {
    const config = {
      method: "get",
      url: `${CollectionDrafttoken}/collections`,
      headers: {
        "Content-Type": "application/json",
      },
    };
    try {
      const res = await axios(config);
      return res.data;
    } catch (error) {
      return error.response.data;
    }
  };
  export const createCollectionDraft = async (data) => {
    const config = {
      method: "post",
      url: `${CollectionDrafttoken}/collections`,
      headers: {
        "Content-Type": "application/json",
      },
      data,
    };
    try {
      const res = await axios(config);
      return res.data;
    } catch (error) {
      return error.response.data;
    }
  };
  export const getCollectionDraftsById = async (id) => {
    const config = {
      method: "get",
      url: `${CollectionDrafttoken}/collections/${id}`,
      headers: {
        "Content-Type": "application/json",
      },
    };
    try {
      const res = await axios(config);
      return res.data;
    } catch (error) {
      return error.response.data;
    }
  };
  export const getCollectionDraftsByWallet = async (walletAddress) => {
    const config = {
      method: "get",
      url: `${CollectionDrafttoken}/collections/wallet/${walletAddress}`,
      headers: {
        "Content-Type": "application/json",
      },
    };
    try {
      const res = await axios(config);
      return res.data;
    } catch (error) {
      return error.response.data;
    }
  };
  export const updateCollectionDraft = async (id, data) => {
    const config = {
      method: "put",
      url: `${CollectionDrafttoken}/collections/${id}`,
      headers: {
        "Content-Type": "application/json",
      },
      data,
    };
    try {
      const res = await axios(config);
      return res.data;
    } catch (error) {
      return error.response.data;
    }
  };
  export const deleteCollectionDraft = async (id) => {
    const config = {
      method: "delete",
      url: `${CollectionDrafttoken}/collections/${id}`,
      headers: {
        "Content-Type": "application/json",
      },
    };
    try {
      const res = await axios(config);
      return res.data;
    } catch (error) {
      return error.response.data;
    }
  };
                  